import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  // 领取人类型
  GIFT_ROLE_TYPE_GIVER: 1, //1送礼人 2收礼人 3其他用户
  GIFT_ROLE_TYPE_RECEIVER: 2,
  GIFT_ROLE_TYPE_ORTHER: 3,


  // 订单类型
  GIFT_ORDER_TYPE_IS_SEND: 1, //送出的
  GIFT_ORDER_TYPE_IS_RECEIVE: 2, //收到的

  // // 领取状态giftOrderStatus
  GIFT_ORDER_STATUS_IS_WAIT_RECEIVED: 1, //待领取
  GIFT_ORDER_STATUS_IS_RECEIVED: 2, //已领取
  GIFT_ORDER_STATUS_IS_RETURNED: 3, //已退回
  GIFT_ORDER_STATUS_IS_CLOSED: 4, //已关闭

  GIFT_BUSINESS_TYPE: 3,

  GIFT_HEADER_BANNER: 37,
  GIFT_OVER_BANNER: 38,
  GIFT_USE_RULE_BANNER: 40,
  GIFT_STATUS_CODE_RECEIVED: 6827002, // 已经被领取
  GIFT_STATUS_CODE_FORBID_RECEIVE: 6827003, // 礼物不允许领取
  GIFT_STATUS_CODE_INVAILD: 6827004, // 礼品已失效
}, km({
    GIFT_GETGIFTORDERLIST_SUCCESS: null,
    GIFT_GETGIFTORDERLIST_ERROR: null,
    GIFT_GETGIFTORDERLIST_MORE_SUCCESS: null,
    GIFT_GETGIFTORDERLIST_MORE_ERROR: null,
    GIFT_GETGIFTORDERDETAIL_SUCCESS: null,
    GIFT_GETGIFTORDERDETAIL_ERROR: null,
    GIFT_RECEIVEGIFT_SUCCESS: null,
    GIFT_RECEIVEGIFT_ERROR: null,
    GIFT_GETGIFTreceiveINFO_SUCCESS: null,
    GIFT_GETGIFTreceiveINFO_ERROR: null,
    GIFT_DELETE_PRODUCTS: null,
    GIFT_SET_INFO: null,
    GIFT_SET_SKU_INFO: null,
    /*yeoman-template-point-1*/
}))
